export default __webpack_public_path__ + "d2093936326f7db399507c7bd25e9ef4.svg";